import { Injectable, Inject } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as actions from '../actions';

import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';

import { Observable, of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';

@Injectable()
export class LoyaltyMessagesEffects {
    public requestMessagesOnSettingsDownloaded$: Observable<Action> = createEffect(() =>
        this._actions$.pipe(
            ofType(actions.AppSettingsSuccessRequest),
            switchMap(() => [actions.LoyaltyMessagesRequest()]),
        ),
    );

    public requestMessages$: Observable<Action> = createEffect(() =>
        this._actions$.pipe(
            ofType(actions.LoyaltyMessagesRequest),
            switchMap(() =>
                this._loyaltyAppService.apiGetMessages().pipe(
                    map((payload) => actions.LoyaltyMessagesSuccessRequest({ payload })),
                    catchError((ex) => {
                        console.error('Request Messages Error', ex);

                        return of(actions.LoyaltyMessagesErrorRequest({ ex }));
                    }),
                ),
            ),
        ),
    );

    constructor(private _actions$: Actions, private _loyaltyAppService: Services.LoyaltyAppService) {}
}
